import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_145_payment_summary: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Payments summary",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: LayoutTypes.GROUP,
            Label: "",
            BindValue: "cont_Action",
            style: {
              direction: FlexDirection.ROW,
              padding: 0,
              margin: 0,
              marginBottom: 8,
            },
            childComponents: [],
          },
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "suppliername",
            Name: "debit_summary",
            BindValue: "grid_debit_summary",
            SummeryActions: [
              {
                Action: {
                  Action: "PDF",
                  Settings: "payment_voucher",
                },
                ActionType: ActionType.PDF_DOWNLOAD,
                tooltip: "Print",
              },
            ],
            Form: {
              Name: "debit_summary",
              TableName: "",
              View: "view_debit_records",
              DisplayName: "debit_summary",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                  IsPrimary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Vendor name",
                  BindValue: "suppliername",
                  Json_Attribute: "suppliername",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Vendor address",
                  BindValue: "address",
                  Json_Attribute: "supplieraddress",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Transaction type",
                  BindValue: "transact_type",
                  Json_Attribute: "transaction_type",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Date",
                  BindValue: "transact_date",
                  Json_Attribute: "date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Amount",
                  BindValue: "transact_debit",
                  Json_Attribute: "debit",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Payment mode",
                  BindValue: "transact_payment_mode",
                  Json_Attribute: "payment_mode",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Details",
                  BindValue: "transact_details",
                  Json_Attribute: "details",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Remarks",
                  BindValue: "transact_remarks",
                  Json_Attribute: "remarks",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Created by",
                  BindValue: "txt_username",
                  Json_Attribute: "username",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
              ],
            },
            FooterControls: [
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_one",
                BindValue: "txt_one",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_2",
                BindValue: "txt_2",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_3",
                BindValue: "txt_3",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "transact_debit_sum",
                IncludeLabel: false,
                Label: "Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "transact_debit_sum",
                Json_Attribute: "",
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:transact_debit]",
                Default_Value: "0",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_6",
                BindValue: "txt_6",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
            ],
          },
          {
            componentType: ComponentType.REPORT,
            Label: "",
            BindValue: "cus_report",
            Settings: "suppliers_report",
            IncludeLabel: true,
            passid: false,
          },
        ],
      },
    ],
  },
];

